/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.6.25",
    versionName: "0.2.0-nightly.2025.6.25",
    versionChannel: "nightly",
    buildDate: "2025-06-25T00:07:42.242Z",
    commitHash: "2c61a7bbebf4ea22997ea7c0bae2ea94a6851ad1",
};
